import { Stack, TableCell, TableRow, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import { DateDisplay } from "lib/@components/dateDisplay"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { Secure } from "lib/authorization/secure"
import Iconify from "minimals-template/components/Iconify"
import { navigateProject } from "authoring/routes/project/utilities/project-navigation"
import { AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function ArchivedProjectRow({ project }) {
    const { name, id, scopedScheduleIds, archivedAt } = project || {}
    const scheduleCount = scopedScheduleIds?.length ?? 0

    return (
        <TableRow onClick={handleClick} sx={{ cursor: "pointer" }} hover data-cy="archived-project-item">
            <TableCell sx={{ whiteSpace: "noWrap", maxWidth: { xs: 150 }, minWidth: { md: 450 } }}>
                <TruncatedTypography>{name}</TruncatedTypography>
            </TableCell>
            <TableCell sx={{ whiteSpace: "noWrap" }} align="right">
                <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={0.5}>
                    <Iconify
                        icon="mdi:drive-document"
                        sx={{ color: "text.secondary", height: "20px", width: "20px" }}
                    />
                    <Typography>{scheduleCount}</Typography>
                </Stack>
            </TableCell>
            <TableCell sx={{ whiteSpace: "noWrap" }}>
                <DateDisplay date={archivedAt} />
            </TableCell>
            <TableCell data-cy="archived-project-item-menu">
                <Stack direction="row" alignItems="center" justifyContent="flex-end" color={grey[500]}>
                    <Secure demand={AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND} fallback={<></>}>
                        <ContextMenuBar type="project" project={project} buttonSx={{ color: grey[600] }} />
                    </Secure>
                </Stack>
            </TableCell>
        </TableRow>
    )

    function handleClick() {
        navigateProject(id)
    }
}
